/* =====================================================================
   MOSAIC: LOCKSMITH MEMBER GATE, "Apply for membership" destination.

   Locksmith serves locked pages from its own stored copy of an older
   Mosaic login page. assets/mosaic-gate.css has the full story; the
   part that matters here is that the copy sends "Apply for membership"
   to /account/register.

   That is the wrong door. Mosaic membership is applied for and
   reviewed individually, and /account/register is Shopify's
   self-serve create-account form, so following it produces an account
   nobody approved. templates/customers/login.liquid already sends the
   same line to /pages/apply; this brings the gate in line with it.

   There is no template to correct, because the markup comes from the
   app rather than the theme, and the rendered copy Locksmith keeps in
   snippets/locksmith-content-variables.liquid is rewritten whenever
   Locksmith touches the theme. So the href is corrected here, scoped
   to .mosaic-login so it can never reach another register link on the
   site. /account/register itself is left alone: it is a real, working
   page that carries the quiz fields, and other flows still use it.

   The durable fix is to stop Locksmith serving its own login page at
   all, which is one setting in the Locksmith app rather than a theme
   change. Once that is done this file is harmless and can go.
   ===================================================================== */
(function () {
  'use strict';

  var APPLY_URL = '/pages/apply';

  function repoint() {
    var gate = document.querySelector('.mosaic-login');
    if (!gate) return;

    var links = gate.querySelectorAll(
      'a[href="/account/register"], a[href^="/account/register?"], a[href^="/account/register#"]'
    );

    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute('href', APPLY_URL);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repoint);
  } else {
    repoint();
  }
}());